import { Price } from "@gen/travel/v1/common_pb";
import i18n from "@libs/i18n";

export function formatAmount(amount: number): string {
  return new Intl.NumberFormat(i18n.language, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  }).format(Number(amount) / 100);
}

export function formatPrice(price: Partial<Price> | undefined): string {
  if (!price) return "-";
  return new Intl.NumberFormat(i18n.language, {
    style: "currency",
    currency: price.currency || "EUR",
    minimumFractionDigits: 2,
  }).format(Number(price.amount) / 100);
}
